import React from 'react';
import styles from '../../css/guide.module.css'

const Guide = () => {


  return (
    <div>
      <div id={styles.sub_con_warp}>
        <div className={styles.sub21_con01}>
          <ul>
            <li className={styles.sub22_con01_li}>
              <div className={styles.sub22_con01_num}>
                1
              </div>
              <div className={styles.sub22_text01}>
                어플다운로드를 합니다.
              </div>
              <div className={styles.sub22_img01}>
                <img src="../img10/sub22_con01-1.png" alt='image_01' />
              </div>
            </li>
            <li className={styles.sub22_con01_li}>
              <div className={styles.sub22_con01_num}>
                2
              </div>
              <div className={styles.sub22_text01}>
                다운로드 완료 후 <br />
                내파일에서 실행해주세요
              </div>
              <div className={styles.sub22_img01}>
                <img src="../img10/sub22_con01-2.png" alt='image_02' />
              </div>
            </li>
            <li className={styles.sub22_con01_li}>
              <div className={styles.sub22_con01_num}>
                3
              </div>
              <div className={styles.sub22_text01}>
                설치완료시 아이콘 생성되며 <br />
                열기를 눌러주세요
              </div>
              <div className={styles.sub22_img01} >
                <img src="../img10/sub22_con01-3.png" alt='image_03' />
              </div>
            </li>
            <li className={styles.sub22_con01_li}>
              <div className={styles.sub22_con01_num}>
                4
              </div>
              <div className={styles.sub22_text01}>
                알림권한 허용해주세요
              </div>
              <div className={styles.sub22_img01}>
                <img src="../img10/sub22_con01-4.png" alt='image_04' />
              </div>
            </li>
            <li className={styles.sub22_con01_li}>
              <div className={styles.sub22_con01_num}>
                5
              </div>
              <div className={styles.sub22_text01}>
                위치권한변경을  해주세요
              </div>
              <div className={styles.sub22_img01}>
                <img src="../img10/sub22_con01-5.png" alt='image_05' />
              </div>
            </li>
            <li className={styles.sub22_con01_li}>
              <div className={styles.sub22_con01_num}>
                6
              </div>
              <div className={styles.sub22_text01}>
                애플리케이션정보에서 <br />
                권한을 클릭해주세요
              </div>
              <div className={styles.sub22_img01}>
                <img src="../img10/sub22_con01-6.png" alt='image_06' />
              </div>
            </li>
            <li className={styles.sub22_con01_li}>
              <div className={styles.sub22_con01_num} >
                7
              </div>
              <div className={styles.sub22_text01}>
                앱권한에서 위치를 <br />
                클릭해주세요
              </div>
              <div className={styles.sub22_img01}>
                <img src="../img10/sub22_con01-7.png" alt='image_07' />
              </div>
            </li>
            <li className={styles.sub22_con01_li}>
              <div className={styles.sub22_con01_num}>
                8
              </div>
              <div className={styles.sub22_text01} >
                위치 액세스 권한에서 <br />
                항상허용으로 설정해주세요
              </div>
              <div className={styles.sub22_img01}>
                <img src="../img10/sub22_con01-8.png" alt='image_08' />
              </div>
            </li>
            <li className={styles.sub22_con01_li}>
              <div className={styles.sub22_con01_num}>
                9
              </div>
              <div className={styles.sub22_text01}>
                설치완료
              </div>
              <div className={styles.sub22_img01}>
                <img src="../img10/sub22_con01-9.png" alt='image_09' />
              </div>
            </li>
          </ul>
        </div> 
{/*    
        <div className={styles.sub_title}>
          <p className={styles.sub_title_text01}>가맹점 설치가이드</p>
        </div>

        <div className={styles.sub22_con02}>
          <img src="../img10/sub22_con02-1.png" alt='image_10' />
        </div>
*/}
      </div>
    </div>
  );
}

export default Guide;
